import { apiSlice } from "../stores/base/api-slice";

const waitlistEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		postWaitlist: builder.mutation<
			{
				fullName: string;
				phoneNumber: string;
				email: string;
				address: string;
				meterNumber: number;
				isBussiness: boolean;
			},
			any
		>({
			query: request => ({
				url: `/waitlist`,
				method: "POST",
				body: request,
			}),
		}),
	}),
});

export const { usePostWaitlistMutation } = waitlistEndpoints;